<div class="login-wrapper">
  <div class="login-card">
    <div class="brand-section">
      <img alt="Mer Logo" class="brand-logo" src="assets/logo.jpg">
      <h1 class="brand-title">Admin Portal</h1>
      <p class="brand-subtitle">Sign in to access your dashboard</p>
    </div>

    <div class="action-section">
      <button class="ms-signin-button" (click)="signInClicked()" data-testid="signInMicrosoft" type="button">
        <img alt="Microsoft logo" class="ms-logo" src="assets/Microsoft_logo.svg">
        <span>Sign in with Microsoft</span>
      </button>
    </div>
  </div>
</div>
